import useAccountCompletion from './useAccountCompletion';
import { CompletionProgress } from '../types';

function useCompletionProgress(): CompletionProgress {
  const milestones = useAccountCompletion();
  return {
    milestonesLength: milestones.length,
    milestonesComplete: milestones.filter((milestone) => milestone.complete)
      .length,
  };
}

export default useCompletionProgress;
